
const handleToTop = (el) => {
    el.addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo(0, 0);
    });
};

export default handleToTop;



// WEBPACK FOOTER //
// ./src/scripts/components/global/handleScrollToTop.js